import { useSuspenseQuery } from "@tanstack/react-query";
import { pathPickSearchProductsQueryApi } from "@/features/pathpick/features/search-products/api/query";
import { PathPickFilterInfoResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

const useGetPathPickFilterInfo = () => {
  const { companyId } = useCompanyIdentity();

  const { data: pathPickFilterInfo } = useSuspenseQuery({
    queryKey: ["pathpick", "filter-info", companyId],
    queryFn: companyId
      ? () => pathPickSearchProductsQueryApi.getPathPickFilterInfo(companyId)
      : undefined,
    select: (data) => toCamelKeyObject(data) as PathPickFilterInfoResponse,
  });

  return { pathPickFilterInfo };
};

export default useGetPathPickFilterInfo;
